// Who may change part families: their name, description and members. Mirrors the
// API's family-editor rule and the `familyEditor` gate key in navigation/menuConfig.js.
// Admin-only fields (Active, stale-box days) stay behind isadmin || can_admin.

export interface FamilyAccessUser {
  isadmin?: boolean;
  can_admin?: boolean;
  can_procurement?: boolean;
  can_manufacturing?: boolean;
  can_manager?: boolean;
}

export const canEditFamilies = (user: FamilyAccessUser | null | undefined): boolean =>
  !!(
    user
    && (user.isadmin
      || user.can_admin
      || user.can_procurement
      || (user.can_manufacturing && user.can_manager))
  );

export const isFamilyAdmin = (user: FamilyAccessUser | null | undefined): boolean =>
  !!(user && (user.isadmin || user.can_admin));
